import { render, staticRenderFns } from "./ItserveRoute.vue?vue&type=template&id=a9d83e4c&"
import script from "./ItserveRoute.vue?vue&type=script&lang=js&"
export * from "./ItserveRoute.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports